import type { Features } from 'utils/account/types';

import type { WidgetDefinition, WidgetId } from './types';
import { ALL_WIDGET_IDS, WIDGET_REGISTRY } from './widgetRegistry';

export type WidgetAvailability = 'available' | 'unavailable' | 'pending';

export type FeatureAccess = {
  features: Features;
  loading: boolean;
  error?: unknown;
};

export function getWidgetAvailability(
  definition: Pick<WidgetDefinition, 'requiredFeatures'>,
  access: FeatureAccess
): WidgetAvailability {
  if (definition.requiredFeatures.every(feature => access.features[feature])) {
    return 'available';
  }
  return access.loading || access.error ? 'pending' : 'unavailable';
}

export function getAvailableWidgetIds(access: FeatureAccess): WidgetId[] {
  return ALL_WIDGET_IDS.filter(
    id => getWidgetAvailability(WIDGET_REGISTRY[id], access) === 'available'
  );
}
